import axiosInstance from "global/helpers/axiosInstance";
import axiosLogin from "global/helpers/axiosLogin";

export const wsDeleteImagenes = (idTurno, nextStep) => (dispatch) => {
    axiosLogin().then((respuesta) => {
      respuesta
        .delete(`/dis/informes/ordenes/${!idTurno ? -1 : idTurno}`)
        .then((res) => {
          if (nextStep) nextStep(true);
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
            origen: "portal",
          };
          if (nextStep) nextStep(false);
        });
    });
  };